import { useQuery } from '@tanstack/react-query';
import type { ShopData } from '../api/site/types';
import { isShopify, useEnv } from '../context/env-context';
import { useHandlers, useSite } from '../context/page-context';

const TAX_QUERY_KEY = 'get-tax';

export function useTax() {
  const { apis } = useHandlers();
  const env = useEnv();
  const site = useSite();

  async function fetchTax() {
    return await apis.site.shop(site.siteId, site.siteEnv);
  }

  const query = useQuery<ShopData>({
    queryKey: [TAX_QUERY_KEY, site.siteId, site.siteEnv],
    queryFn: fetchTax,
    enabled: isShopify(env.connected_platform),
  });

  return {
    tax: query.data ?? null,
    refetch: query.refetch,

    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
  };
}
